export enum ViewState {
  Loading = 'loading',
  PinEntry = 'pin-entry',
  Success = 'success',
  Error = 'error'
}

export const enum OAuthErrorCode {
  AccessDenied = 'access_denied',
  InvalidRequest = 'invalid_request'
}

export const enum SignatureErrorCode {
  PinLocked = 'PIN_Locked',
  InvalidPin = 'Invalid_PIN',
  SessionExpired = 'SignatureSessionExpired',
  SessionNotFound = 'SignatureSessionNotFound',
  SessionInvalidStatus = 'SignatureSessionInvalidStatus'
}

export const enum QueryParamKey {
  Code = 'code',
  Error = 'error',
  ErrorDescription = 'error_description',
  SessionId = 'sessionId',
  FileIds = 'fileIds'
}
